import { TITLE_ICON } from '@app/core/cms-flex/types';

import { TitleImage } from '../types';

export const TITLE_IMAGE = new Map<TITLE_ICON, TitleImage>()
  .set(TITLE_ICON.PEOPLE, '/images/people.svg')
  .set(TITLE_ICON.IDEA, '/images/ideas.svg')
  .set(TITLE_ICON.CHECK, '/images/check.svg')
  .set(TITLE_ICON.PATH, '/images/path.svg');
